import React from 'react';
import { Card, CardContent, CardHead, CardTitle, ScrollBarWithFade } from '@payler/ui-components';
import { FullWidthBlock } from '../../layouts';
import { HStack, chakra } from '@chakra-ui/react';
import NumberFormat from 'react-number-format';
import { TBalance } from '../../../../../api/src';
import { useCurrencyCallbacks } from '../../hooks/currencies-info';
import { TextStyles } from '@payler/ui-theme';

type BalancesStripProps = {
  title?: string;
  balances?: TBalance | TBalance[];
};

export const BalancesStrip: React.FC<BalancesStripProps> = ({ title, balances }) => {
  const { getCurrencyUnitRate, getCurrencyDecimalsCount, getCurrencySymbol } =
    useCurrencyCallbacks();

  const balancesArray: TBalance[] = Array.isArray(balances)
    ? balances
    : balances
    ? [balances]
    : [];
  if (balancesArray.length === 0) return null;

  const content = (
    <ScrollBarWithFade>
      <HStack spacing={2} minW="100%" justifyContent="space-between">
        {balancesArray.map((x, i) => (
          <Card key={i} minW="250px" borderRadius={1.5} flex={1}>
            <CardContent>
              <chakra.h5
                textStyle={TextStyles.Caption12Regular}
                color="primary.350"
                mb={1}
              >
                {x.name ?? 'Баланс'}
              </chakra.h5>
              <chakra.p textStyle={TextStyles.h4}>
                <NumberFormat
                  displayType="text"
                  suffix={`\u00a0${getCurrencySymbol(x.currencyCode)}`}
                  decimalScale={getCurrencyDecimalsCount(x.currencyCode)}
                  fixedDecimalScale
                  thousandSeparator={' '}
                  value={x.amount / getCurrencyUnitRate(x.currencyCode)}
                />
              </chakra.p>
            </CardContent>
          </Card>
        ))}
      </HStack>
    </ScrollBarWithFade>
  );

  // With title, wrap into a Card; otherwise render simple strip as before
  if (title) {
    return (
      <FullWidthBlock gridArea="balances" mb={4}>
        <Card borderRadius={1.5}>
          <CardHead>
            <CardTitle>{title}</CardTitle>
          </CardHead>
          <CardContent>{content}</CardContent>
        </Card>
      </FullWidthBlock>
    );
  }

  return <FullWidthBlock gridArea="balances" mb={4}>{content}</FullWidthBlock>;
};

export default BalancesStrip;


